import React, { Component } from 'react'
import './ManPower.css'
let manpower = 'Details not available'
class ManPower extends Component {
    constructor(props) {
        super(props)
    }
    componentWillReceiveProps(nextProps){
        manpower=nextProps.transporter_data.manpower_details;
        if(manpower==undefined || manpower==null){
            manpower='Details not available'
        }
    }
    render() {
        return (
         //   <div className="container" style={{marginTop:'5%'}}>
                <div className="manpowercard">
                    <div className="manpowercontainer">
                        <span className="data_header">Manpower Details</span>
                        { (manpower=='Details not available' || (!manpower.management_staff&&!manpower.drivers&&!manpower.maintenance_staff))?(<div><b>Details not available</b></div>):(<div>
                        <div className="manpowerDetails">{(manpower.management_staff==null||manpower.management_staff==undefined||manpower.management_staff=='')?(''):(<><b>Management Staff: </b> {manpower.management_staff}</>)}</div>
                        <div className="manpowerDetails">{(manpower.drivers==null||manpower.drivers==undefined||manpower.drivers=='')?(''):(<><b>Drivers: </b> {manpower.drivers}</>)}</div>
                        <div className="manpowerDetails">{(manpower.maintenance_staff==null||manpower.maintenance_staff==undefined||manpower.maintenance_staff=='')?(''):(<><b>Maintenance Staff: </b> {manpower.maintenance_staff}</>)}</div>
                        </div>)}
                    </div>
                </div>
           // </div>
        )
    }
}

export default ManPower
